export default __webpack_public_path__ + "static/media/work-5c.37de39a0.png";